var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "scrollbox", staticClass: "message-wrapper" },
    [
      _vm.msgList.length && _vm.ajaxDone
        ? _c(
            "ul",
            { ref: "scrollList", staticClass: "message-list" },
            [
              _vm._l(_vm.msgList, function(msg, index) {
                return _c(
                  "li",
                  {
                    staticClass: "message-list-item",
                    on: {
                      click: function($event) {
                        return _vm.goDetail2(msg)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "head-img",
                      attrs: {
                        src: msg.HeadImage || "/static/images/default.png"
                      },
                      on: { error: _vm.$imgErr }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "reply" }, [
                      _c("div", { staticClass: "replyer-title" }, [
                        _c("div", { staticClass: "replyer-name" }, [
                          _vm._v(_vm._s(msg.ReplyName))
                        ]),
                        _vm._v(" "),
                        msg.Identity == 1
                          ? _c("div", { staticClass: "knowledge-expert" }, [
                              _c("img", {
                                attrs: {
                                  src: "/static/images/knowledge_expert.png",
                                  alt: ""
                                }
                              })
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      !msg.IsDel
                        ? _c("div", [
                            msg.Comment
                              ? _c("div", { staticClass: "reply-content" }, [
                                  msg.ReplyToADAccount
                                    ? _c("span", [_vm._v("回复了我：")])
                                    : _vm._e(),
                                  _vm._v(_vm._s(msg.Comment))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            msg.AttachList && msg.AttachList.length
                              ? _c(
                                  "div",
                                  { staticClass: "reply-img" },
                                  _vm._l(msg.AttachList, function(imgs, i) {
                                    return _c(
                                      "picture",
                                      {
                                        staticClass: "picture",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showImg(
                                              i,
                                              msg.AttachList
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "source-img",
                                          attrs: { src: imgs },
                                          on: { error: _vm.$imgErr }
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        : _c("div", { staticClass: "deleted-box" }, [
                            _c("span", { staticClass: "left-cane" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "delete-tip" }, [
                              _vm._v("评论已删除")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "right-cane" })
                          ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.hasUnread
                ? _c(
                    "span",
                    {
                      staticClass: "view-history-msg",
                      on: { click: _vm.showHistoryMsg }
                    },
                    [_vm._v("展开消息列表")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("loading-more")
            ],
            2
          )
        : _vm.ajaxDone
        ? _c("div", { staticClass: "no-message" }, [
            _vm._v("\n        暂未收到回复\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.sourceList && _vm.sourceList.length
        ? _c("photo-package", {
            ref: "sourcePreview",
            attrs: {
              list: _vm.sourceList,
              options: _vm.options,
              selector: ".source-img"
            },
            on: { "on-close": _vm.closeHandler }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("water-mark", { ref: "watermark" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-55ffbf55", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-55ffbf55","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/message/message.vue
// module id = null
// module chunks = 